import React, { Fragment } from "react";
import Navbar2 from "../../components/Navbar2";
import PageTitle from "../../components/pagetitle";
import Admin from "../../components/Admin";
import Footer from "../../components/footer";
import Scrollbar from "../../components/scrollbar";

const AdminPage = () => {
  return (
    <Fragment>
      <Navbar2 hclass={"wpo-header-style-2"} topbarBlock={"topbar-block"} />
      <PageTitle pageTitle={"Admin"} pagesub={"Admin"} />
      <Admin />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default AdminPage;
